var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
/* eslint-disable no-plusplus */
import React, { useState, useContext, useMemo, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { gql, useApolloClient } from '@apollo/client';
import { MediaContext } from 'react-media-query-hoc';
import AutocompleteDropdown from './dropdown';
import AutocompleteModal from './modal';
import withGraphQLProvider from './utils/with-graphql-provider';
import { MIN_QUERY_LENGTH } from './utils/constants';
import * as autocompletePropTypes from './utils/prop-types';
import AutocompleteType from './utils/autocomplete-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AUTOCOMPLETE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query autocomplete($query: String!, $types: [AutocompleteType!]!) {\n    autocomplete(query: $query, types: $types) {\n      id\n      name\n      type\n      description\n      url\n      slug\n      id\n      state {\n        abbrev\n      }\n      image\n    }\n  }\n"])));
var DEFAULT_TYPES = [AutocompleteType.DIVISION.name, AutocompleteType.DISTRICT.name, AutocompleteType.POSTCODE.name, AutocompleteType.REGION.name];
var AllhomesAutocomplete = _ref => {
  var _ref$initialSelectedI = _ref.initialSelectedItems,
    initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
    placeholder = _ref.placeholder,
    mobilePlaceholder = _ref.mobilePlaceholder,
    alwaysOpen = _ref.alwaysOpen,
    inputType = _ref.inputType,
    singleSelect = _ref.singleSelect,
    showEmptySheet = _ref.showEmptySheet,
    noBorder = _ref.noBorder,
    buttonText = _ref.buttonText,
    notFoundText = _ref.notFoundText,
    pending = _ref.pending,
    invalid = _ref.invalid,
    _ref$types = _ref.types,
    types = _ref$types === void 0 ? DEFAULT_TYPES : _ref$types,
    _ref$immediateTypes = _ref.immediateTypes,
    immediateTypes = _ref$immediateTypes === void 0 ? [] : _ref$immediateTypes,
    buildGroupName = _ref.buildGroupName,
    variant = _ref.variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    title = _ref.title,
    className = _ref.className,
    recentSearchKey = _ref.recentSearchKey,
    saveRecentOnSearch = _ref.saveRecentOnSearch,
    extensions = _ref.extensions,
    onSearch = _ref.onSearch,
    onCloseModal = _ref.onCloseModal,
    onEntryClick = _ref.onEntryClick,
    onImmediateSearch = _ref.onImmediateSearch,
    onRecentSearch = _ref.onRecentSearch,
    onLoadedRecentSearches = _ref.onLoadedRecentSearches,
    onSelectionChange = _ref.onSelectionChange,
    onDropdownOpen = _ref.onDropdownOpen,
    allowDefaultSearch = _ref.allowDefaultSearch;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    desktop = _useContext.desktop;
  var requestId = useRef(0);
  var lastAccepted = useRef(0);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    queryText = _useState2[0],
    setQueryText = _useState2[1];
  var _useState3 = useState(initialSelectedItems),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItems = _useState4[0],
    setSelectedItems = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    suggestions = _useState6[0],
    setSuggestions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var apolloClient = useApolloClient();
  var doQuery = useMemo(() => debounce(text => {
    setLoading(true);
    requestId.current++;
    var thisRequest = requestId.current;
    apolloClient.query({
      query: AUTOCOMPLETE,
      variables: {
        query: text,
        types
      }
    }).then(result => {
      if (lastAccepted.current < thisRequest) {
        var _result$data;
        lastAccepted.current = thisRequest;
        setSuggestions((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.autocomplete);
        setLoading(false);
      }
      setError(false);
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  }, 100), [apolloClient, types]);
  var updateQueryText = text => {
    if ((text === null || text === void 0 ? void 0 : text.length) >= MIN_QUERY_LENGTH) {
      doQuery(text);
    } else {
      setSuggestions([]);
    }
    setQueryText(text);
  };

  /* Re-run the query if the types change */
  useEffect(() => {
    if ((queryText === null || queryText === void 0 ? void 0 : queryText.length) >= MIN_QUERY_LENGTH) {
      doQuery(queryText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [types, doQuery]); // Don't need to update on `queryText` change, since that's covered elsewhere

  var handleSelectionChange = useCallback(newItems => {
    setSelectedItems(newItems);
    onSelectionChange(newItems);
  }, [onSelectionChange]);
  var resetSuggestions = () => {
    setQueryText();
    setSuggestions();
  };
  var isModal = variant ? variant === 'modal' : mobile;
  var selectedPlaceholder = desktop ? placeholder : mobilePlaceholder || placeholder;
  var autocompleteProps = {
    loading,
    error: Boolean(error),
    queryText,
    setQueryText: updateQueryText,
    suggestions,
    recentSearchKey,
    onLoadedRecentSearches,
    initialSelectedItems: selectedItems,
    placeholder: selectedPlaceholder,
    alwaysOpen,
    pending,
    invalid,
    inputType,
    singleSelect,
    showEmptySheet,
    noBorder,
    notFoundText,
    title,
    buttonText,
    types,
    immediateTypes,
    buildGroupName,
    className,
    saveRecentOnSearch,
    onSearch,
    onImmediateSearch,
    onRecentSearch,
    onSelectionChange: handleSelectionChange,
    onEntryClick,
    resetSuggestions,
    onDropdownOpen,
    allowDefaultSearch
  };
  if (isModal) {
    return ___EmotionJSX(AutocompleteModal, _extends({}, autocompleteProps, {
      onCloseModal: onCloseModal,
      extensions: {
        placeholder: extensions === null || extensions === void 0 ? void 0 : extensions.modalPlaceholder,
        suggestionSheet: extensions === null || extensions === void 0 ? void 0 : extensions.modalSuggestionSheet,
        suggestionHeading: extensions === null || extensions === void 0 ? void 0 : extensions.suggestionHeading
      }
    }));
  }
  return ___EmotionJSX(AutocompleteDropdown, _extends({
    size: size
  }, autocompleteProps, {
    extensions: {
      suggestionHeading: extensions === null || extensions === void 0 ? void 0 : extensions.suggestionHeading
    }
  }));
};
AllhomesAutocomplete.propTypes = {
  title: PropTypes.string,
  initialSelectedItems: autocompletePropTypes.valueList,
  size: autocompletePropTypes.size,
  pending: PropTypes.bool,
  invalid: PropTypes.bool,
  variant: autocompletePropTypes.variants,
  inputType: autocompletePropTypes.inputType,
  alwaysOpen: PropTypes.bool,
  singleSelect: PropTypes.bool,
  showEmptySheet: PropTypes.bool,
  noBorder: PropTypes.bool,
  buttonText: PropTypes.string,
  notFoundText: PropTypes.string,
  types: autocompletePropTypes.types,
  immediateTypes: autocompletePropTypes.types,
  buildGroupName: autocompletePropTypes.buildGroupName,
  placeholder: PropTypes.string,
  extensions: autocompletePropTypes.extensions,
  mobilePlaceholder: PropTypes.string,
  recentSearchKey: PropTypes.string,
  saveRecentOnSearch: PropTypes.bool,
  className: PropTypes.string,
  onSearch: PropTypes.func,
  onImmediateSearch: PropTypes.func,
  onRecentSearch: PropTypes.func,
  onLoadedRecentSearches: PropTypes.func,
  onSelectionChange: PropTypes.func,
  onEntryClick: PropTypes.func,
  onCloseModal: PropTypes.func,
  onDropdownOpen: PropTypes.func,
  allowDefaultSearch: PropTypes.bool
};
AllhomesAutocomplete.defaultProps = {
  title: 'Search',
  initialSelectedItems: [],
  size: 'normal',
  variant: null,
  inputType: 'standalone',
  pending: false,
  invalid: false,
  alwaysOpen: false,
  singleSelect: false,
  showEmptySheet: false,
  noBorder: false,
  buttonText: undefined,
  notFoundText: 'Sorry, no suggestions for that search',
  placeholder: 'Type a location',
  extensions: undefined,
  types: DEFAULT_TYPES,
  immediateTypes: [],
  buildGroupName: undefined,
  mobilePlaceholder: undefined,
  recentSearchKey: undefined,
  saveRecentOnSearch: false,
  className: undefined,
  onSearch: () => {},
  onImmediateSearch: undefined,
  onRecentSearch: undefined,
  onLoadedRecentSearches: () => {},
  onSelectionChange: () => {},
  onEntryClick: () => {},
  onCloseModal: () => {},
  onDropdownOpen: () => {},
  allowDefaultSearch: false
};
export default withGraphQLProvider(AllhomesAutocomplete);